(function(){
  'use strict';

  if (window.__lbfBundleCartGroupReady) return;
  window.__lbfBundleCartGroupReady = true;

  function moneyFromText(value){
    var n = parseFloat(String(value || '0').replace(/,/g, ''));
    if (!isFinite(n)) n = 0;
    return 'RM' + n.toFixed(2);
  }

  function parsePrice(value){
    var n = parseFloat(String(value || '0').replace(/,/g, ''));
    return isFinite(n) ? n : 0;
  }

  function esc(value){
    return String(value == null ? '' : value).replace(/[&<>"']/g, function(c){
      return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c];
    });
  }

  function selectorEscape(value){
    if (window.CSS && typeof window.CSS.escape === 'function') return window.CSS.escape(String(value));
    return String(value).replace(/["\\]/g, '\\$&');
  }

  function getColumnCount(table){
    var ths = table ? table.querySelectorAll('thead th') : [];
    return Math.max(ths.length || 0, 4);
  }

  function buildSummaryRow(table, id, rows){
    var first = rows[0];
    var name = first.dataset.lbfBundleName || 'Ready To Eat Box';
    var source = first.dataset.lbfBundleSource || '/pages/build-your-rte-bundle';
    var editUrl = addQueryParam(source || '/pages/build-your-rte-bundle', 'bb_edit', id);
    var itemCount = rows.reduce(function(sum, row){ return sum + (parseInt(row.dataset.lbfLineQty, 10) || 0); }, 0);
    var total = rows.reduce(function(sum, row){ return sum + parsePrice(row.dataset.lbfLinePrice); }, 0);
    var image = first.dataset.lbfLineImage || '';
    var lines = rows.map(function(row){
      var qty = parseInt(row.dataset.lbfLineQty, 10) || 0;
      return '<li>' + qty + ' x ' + esc(row.dataset.lbfLineTitle || '') + '</li>';
    }).join('');
    var detailsLabel = itemCount + ' selected dishes';
    var row = document.createElement('tr');
    row.className = 'lbf-cart-bundle-summary';
    row.dataset.lbfBundleSummary = id;
    row.innerHTML =
      '<td colspan="' + getColumnCount(table) + '">' +
        '<div class="lbf-cart-bundle-card">' +
          '<div class="lbf-cart-bundle-card__media">' + (image ? '<img src="' + esc(image) + '" alt="" loading="lazy">' : '') + '</div>' +
          '<div class="lbf-cart-bundle-card__body">' +
            '<h3 class="lbf-cart-bundle-card__title">' + esc(name) + '</h3>' +
            '<details class="lbf-cart-bundle-card__details" open>' +
              '<summary>' + esc(detailsLabel) + '</summary>' +
              '<ul class="lbf-cart-bundle-card__items">' + lines + '</ul>' +
            '</details>' +
          '</div>' +
          '<div class="lbf-cart-bundle-card__side">' +
            '<div class="lbf-cart-bundle-card__price">' + moneyFromText(total) + '</div>' +
            '<a class="lbf-cart-bundle-card__edit" href="' + esc(editUrl) + '">Edit on builder page</a>' +
            '<button type="button" class="lbf-cart-bundle-card__remove" data-lbf-remove-bundle="' + esc(id) + '">Remove bundle</button>' +
          '</div>' +
        '</div>' +
      '</td>';
    return row;
  }

  function addQueryParam(url, key, value){
    var base = String(url || '/pages/build-your-rte-bundle');
    var hash = '';
    var hashIndex = base.indexOf('#');
    if (hashIndex !== -1) {
      hash = base.slice(hashIndex);
      base = base.slice(0, hashIndex);
    }
    var separator = base.indexOf('?') === -1 ? '?' : '&';
    return base + separator + encodeURIComponent(key) + '=' + encodeURIComponent(value) + hash;
  }

  /* Carl 2026-10-14: idempotent. The drawer refresh (LBF_CART_DRAWER_SYNC) rebuilds the rows it knows and drops the
     summary card, so a "grouped once" flag left the bundle's dishes hidden with no card. Every pass now checks each
     bundle has its card in place and rebuilds only what is missing or out of date, so the observer settles. */
  function groupInTable(table){
    if (!table) return;
    var rows = Array.prototype.slice.call(table.querySelectorAll('tr[data-lbf-bundle-line="true"]'));
    var groups = {}, order = [];
    rows.forEach(function(row){
      var id = row.dataset.lbfBundleId || 'bundle';
      if (!groups[id]) { groups[id] = []; order.push(id); }
      groups[id].push(row);
    });

    Array.prototype.slice.call(table.querySelectorAll('tr.lbf-cart-bundle-summary')).forEach(function(summary){
      if (!groups[summary.dataset.lbfBundleSummary]) summary.remove();
    });

    order.forEach(function(id){
      var groupRows = groups[id];
      groupRows.forEach(function(row){
        if (!row.classList.contains('lbf-cart-bundle-row') || !row.classList.contains('is-hidden')) row.classList.add('lbf-cart-bundle-row', 'is-hidden');
        if (row.getAttribute('aria-hidden') !== 'true') row.setAttribute('aria-hidden', 'true');
      });
      var sig = groupRows.map(function(row){
        return (row.dataset.lbfLineKey || '') + ':' + (row.dataset.lbfLineQty || '') + ':' + (row.dataset.lbfLinePrice || '');
      }).join('|');
      var existing = table.querySelector('[data-lbf-bundle-summary="' + selectorEscape(id) + '"]');
      if (existing && existing.dataset.lbfBundleSig === sig && existing.nextElementSibling === groupRows[0]) return;
      if (existing) existing.remove();
      var summary = buildSummaryRow(table, id, groupRows);
      summary.dataset.lbfBundleSig = sig;
      groupRows[0].insertAdjacentElement('beforebegin', summary);
    });

    if (rows.length) table.dataset.lbfBundleGrouped = 'true';
  }

  function groupBundles(root){
    (root || document).querySelectorAll('table.cart-items').forEach(groupInTable);
  }

  function removeBundle(id, button){
    var rows = Array.prototype.slice.call(document.querySelectorAll('tr[data-lbf-bundle-id="' + selectorEscape(id) + '"]'));
    var updates = {};
    rows.forEach(function(row){
      if (row.dataset.lbfLineKey) updates[row.dataset.lbfLineKey] = 0;
    });
    if (!Object.keys(updates).length) return;
    if (button) button.disabled = true;
    fetch('/cart/update.js', {
      method:'POST',
      headers:{'Content-Type':'application/json','Accept':'application/json'},
      body:JSON.stringify({updates:updates})
    })
      .then(function(response){ return response.json(); })
      .then(function(){
        if (typeof PUB_SUB_EVENTS !== 'undefined' && typeof publish === 'function') {
          publish(PUB_SUB_EVENTS.cartUpdate, {source:'lbf-bundle-cart-group'});
        } else {
          window.location.reload();
        }
      })
      .catch(function(){
        if (button) button.disabled = false;
        window.location.href = '/cart';
      });
  }

  document.addEventListener('click', function(event){
    var button = event.target.closest('[data-lbf-remove-bundle]');
    if (!button) return;
    event.preventDefault();
    removeBundle(button.getAttribute('data-lbf-remove-bundle'), button);
  });

  document.addEventListener('DOMContentLoaded', function(){ groupBundles(document); });
  document.addEventListener('cart:updated', function(){ window.setTimeout(function(){ groupBundles(document); }, 50); });
  if (typeof PUB_SUB_EVENTS !== 'undefined' && typeof subscribe === 'function') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, function(){ window.setTimeout(function(){ groupBundles(document); }, 150); });
  }

  new MutationObserver(function(){ groupBundles(document); }).observe(document.documentElement, {childList:true, subtree:true});
})();
